import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PortalUser } from '@interfaces/portalUser';
import { IServerResponse } from '@interfaces/server';
import { Observable } from 'rxjs';
import { default_headers } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class Wso2CoreService {
  private params: HttpParams;

  constructor(private readonly http: HttpClient) { }

  contactFindByContactId(contactId: number) :  Observable<PortalUser> {
    const url = `/apiconnect/company-data/contacts/${contactId}`;
    return this.http.get<PortalUser>(url);
  }

  contactFindByCpf(): Observable<PortalUser> {
    const url = `/apiconnect/company-data/contacts`;
    return this.http.get<PortalUser>(url);
  }

  saveContact(contact: any) : Observable<IServerResponse> {
    this.setParameterPortalUser('userCreatorId');
    const url = `/apiconnect/company-data/contacts`;
    return this.http.post<IServerResponse>(url, contact, { headers: default_headers, params: this.params });

  }

  updateContact(contactId: string, contact: any) : Observable<IServerResponse> {
    this.setParameterPortalUser('userUpdateId');
    const url = `/apiconnect/company-data/contacts/${contactId}`;
    return this.http.put<IServerResponse>(url, contact, { headers: default_headers, params: this.params });
  }

  toggleUser(contactId: any, enabled: boolean) : Observable<IServerResponse> {
    this.setParameterPortalUser('userUpdateId');
    const url: string = `/apiconnect/company-data/contacts/${contactId}/portal-access`;
    const hasAccess = enabled ? 'Y' : 'N';
    this.params ??= new HttpParams();
    this.params = this.params.set("hasAccess", hasAccess);

    return this.http.put<IServerResponse>(url, null, {params: this.params} );
  }

  updateContactPermission(cpf: string, loginType: string) : Observable<any> {
    const url = '/apiconnect/company-data/contacts';
    let params = new HttpParams()
      .set('userCpf', cpf)
      .set('loginType', loginType);

    return this.http.put(url, null,{params: params});
  }

  findContactLevel(): Observable<any> {
    const url = `/apiconnect/company-data/contacts/levels`;
    return this.http.get(url);
  }

  equatePermission(contactId: string) : Observable<any> {
    const url = '/apiconnect/company-data/permission/equate';
    let params = new HttpParams()
      .set('contactId', contactId);

    return this.http.post(url, null,{params: params});
  }


  private setParameterPortalUser(parameterName: string) {
    const portalUserId = localStorage.portalUserId;
    if (portalUserId !== undefined) {
      const obj = {}
      obj[parameterName] = portalUserId;
      this.params = new HttpParams({fromObject: obj});
    }
  }

  mergePermission() : Observable<any> {
    const url = '/apiconnect/company-data/contacts/merge';
    return this.http.put(url, null);
  }

}

